const style = () => ({
    display: "flex",
    flex: 1,
    height: "100%",
    form: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        height: "100%",
    },
});

export default style;
